import { notification, Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

const antIcon = <LoadingOutlined style={{ fontSize: 16 }} spin />;

const notificationStyle = {
	warning: { backgroundColor: '#D4EAFF', border: '1px solid #52ACFF' },
	success: { backgroundColor: '#DFF4D4', border: '1px solid #52C41A' },
	error: { backgroundColor: '#FFDEDE', border: '1px solid #FF4D4F' }
};

const engelStyle = {
	warning: { backgroundColor: '#FFF8E8', border: '1px solid #E6B96E' },
	success: { backgroundColor: '#E7EDD4', border: '1px solid #477306' },
	error: { backgroundColor: '#FBEBEB', border: '1px solid #C80000' }
};

const colorTitle = {
	success: '#3E9314',
	error: '#FF4D4F',
	warning: '#1890FF'
};

const colorEngelTitle = {
	success: '#477306',
	error: '#C80000',
	warning: '#E6B96E'
};

export const commonNotifications = (
	type: 'success' | 'error' | 'warning',
	title: string,
	description: string,
	engel?: boolean
) => {
	const style = engel ? engelStyle[type] : notificationStyle[type];
	const colorText = engel ? colorEngelTitle[type] : colorTitle[type];

	notification[type]({
		message: (
			<div
				style={{
					fontSize: '16px',
					color: colorText,
					fontWeight: 600
				}}>
				{title}
			</div>
		),
		description: (
			<div style={{ fontSize: engel ? '14px' : '12px', color: engel ? '#262626' : '#2F4858' }}>
				{description}
			</div>
		),
		placement: engel ? 'top' : 'topRight',
		duration: type === 'warning' ? 2 : 4,
		icon: type === 'warning' && (
			<div
				className="wrapper-icons-render-cards"
				style={{
					marginTop: -4
				}}>
				<Spin indicator={antIcon} className="spin" />
			</div>
		),
		style: {
			...style,
			borderRadius: 4,
			width: engel ? 'auto' : 480
		}
	});
};
